import React from 'react';

const StarRating = ({ rating }) => {
  const totalStars = 5;
  return (
    <div className="star-rating" style={{ color: '#f5c518', display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 0px' }}>
      <div>
        {[...Array(totalStars)].map((_, index) => (
          <i
            key={index}
            className={index < rating ? 'fas fa-star' : 'far fa-star'}
          ></i>
        ))}
      </div>
      <span style={{ color: '#333', fontSize: '14px' }}>{rating} out of {totalStars}</span>
    </div>
  );
};

export default StarRating;
